export const APP_CONFIG = {
    LOCAL_STORAGE_KEY: {
        ASSET_TABLE_FILTER: 'assetTableFilters',
    }
}